import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const PolicyLinks = styled.div`
  margin-left: 0.6rem 0 0 1.5rem;
  color: ${colors.mainText};
  text-align: left;
  a {
    border-bottom: 1px dashed ${colors.messegesGreen1};
    color: ${colors.messegesGreen1};
  }
  padding-left: 24px;
`
